import { Component, Vue, Prop } from 'vue-property-decorator'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import FormCustomer from '@/Models/formCustomer'
@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
  },
})
export default class FormCustomerStep1 extends Vue {
  step1: FormCustomer = new FormCustomer()
  @Prop({ required: false }) objStep1!: any

  mounted() {
    if (this.objStep1) {
      this.step1 = this.objStep1
    }
  }
  countrySelect() {
    this.$emit('countrySelect', this.step1.country_origin)
  }
  async validateFields() {
    const isValid = await (this.$refs['observer'] as any).validate()
    if (isValid) {
      return true
    } else {
      return false
    }
  }
}
